import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import {
  PERMISO_SECCION_ACCIONES,
  PERMISO_SECCION_CLIENTES,
  PERMISO_SECCION_CONTACTOS,
  PERMISO_SECCION_USUARIOS,
} from './core/models/user.model';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./features/landing/landing-redirect.component').then(
            (m) => m.LandingRedirectComponent,
          ),
      },
      {
        path: '403',
        loadComponent: () =>
          import('./features/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'clientes',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CLIENTES, action: 'view' } },
        loadComponent: () =>
          import('./features/clientes/clientes-list/clientes-list.component').then(
            (m) => m.ClientesListComponent,
          ),
      },
      {
        path: 'clientes/nou',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CLIENTES, action: 'edit' } },
        loadComponent: () =>
          import('./features/clientes/cliente-form/cliente-form.component').then(
            (m) => m.ClienteFormComponent,
          ),
      },
      {
        path: 'clientes/:id/editar',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CLIENTES, action: 'edit' } },
        loadComponent: () =>
          import('./features/clientes/cliente-form/cliente-form.component').then(
            (m) => m.ClienteFormComponent,
          ),
      },
      {
        path: 'clientes/:id',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CLIENTES, action: 'view' } },
        loadComponent: () =>
          import('./features/clientes/cliente-detail/cliente-detail.component').then(
            (m) => m.ClienteDetailComponent,
          ),
      },
      {
        path: 'contactos',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CONTACTOS, action: 'view' } },
        loadComponent: () =>
          import('./features/contactos/contactos-list/contactos-list.component').then(
            (m) => m.ContactosListComponent,
          ),
      },
      {
        path: 'contactos/nou',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CONTACTOS, action: 'edit' } },
        loadComponent: () =>
          import('./features/contactos/contacto-form/contacto-form.component').then(
            (m) => m.ContactoFormComponent,
          ),
      },
      {
        path: 'contactos/:id/editar',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CONTACTOS, action: 'edit' } },
        loadComponent: () =>
          import('./features/contactos/contacto-form/contacto-form.component').then(
            (m) => m.ContactoFormComponent,
          ),
      },
      {
        path: 'contactos/:id',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_CONTACTOS, action: 'view' } },
        loadComponent: () =>
          import('./features/contactos/contacto-detail/contacto-detail.component').then(
            (m) => m.ContactoDetailComponent,
          ),
      },
      {
        path: 'acciones',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_ACCIONES, action: 'view' } },
        loadComponent: () =>
          import('./features/acciones/acciones-list/acciones-list.component').then(
            (m) => m.AccionesListComponent,
          ),
      },
      {
        path: 'acciones/nou',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_ACCIONES, action: 'edit' } },
        loadComponent: () =>
          import('./features/acciones/accion-form/accion-form.component').then(
            (m) => m.AccionFormComponent,
          ),
      },
      {
        path: 'acciones/:id/editar',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_ACCIONES, action: 'edit' } },
        loadComponent: () =>
          import('./features/acciones/accion-form/accion-form.component').then(
            (m) => m.AccionFormComponent,
          ),
      },
      {
        path: 'acciones/:id',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_ACCIONES, action: 'view' } },
        loadComponent: () =>
          import('./features/acciones/accion-detail/accion-detail.component').then(
            (m) => m.AccionDetailComponent,
          ),
      },
      {
        path: 'opciones',
        canActivate: [permissionGuard],
        data: { permission: { action: 'admin' } },
        loadComponent: () =>
          import('./features/opciones/opciones-admin/opciones-admin.component').then(
            (m) => m.OpcionesAdminComponent,
          ),
      },
      {
        path: 'dashboard',
        canActivate: [permissionGuard],
        data: { permission: { action: 'admin' } },
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'auditoria',
        canActivate: [permissionGuard],
        data: { permission: { action: 'admin' } },
        loadComponent: () =>
          import('./features/auditoria/auditoria-list/auditoria-list.component').then(
            (m) => m.AuditoriaListComponent,
          ),
      },
      {
        path: 'usuarios',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_USUARIOS, action: 'view' } },
        loadComponent: () =>
          import('./features/usuarios/usuarios-list/usuarios-list.component').then(
            (m) => m.UsuariosListComponent,
          ),
      },
      {
        path: 'usuarios/nou',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_USUARIOS, action: 'edit' } },
        loadComponent: () =>
          import('./features/usuarios/usuario-form/usuario-form.component').then(
            (m) => m.UsuarioFormComponent,
          ),
      },
      {
        path: 'usuarios/:id/editar',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_USUARIOS, action: 'edit' } },
        loadComponent: () =>
          import('./features/usuarios/usuario-form/usuario-form.component').then(
            (m) => m.UsuarioFormComponent,
          ),
      },
      {
        path: 'usuarios/:id',
        canActivate: [permissionGuard],
        data: { permission: { seccion: PERMISO_SECCION_USUARIOS, action: 'view' } },
        loadComponent: () =>
          import('./features/usuarios/usuario-detail/usuario-detail.component').then(
            (m) => m.UsuarioDetailComponent,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./features/landing/landing-redirect.component').then(
            (m) => m.LandingRedirectComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
